module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido@2x-3b497b258ee66927c606ca858e4bcba6.jpg";